<template>
    <div
        class="SystemsCarouselItem"
        :style="{ opacity: activeSystemId === system.id ? 1 : 0.5 }"
        @mousedown="setMousePosition"
        @mouseup="setMousePosition"
        @click="handleClick"
    >
        <div class="CarouselCard">
            <h4>{{ system.label }}</h4>
            <img src="https://picsum.photos/200/300" alt="system" />
        </div>
        <h3 class="title">
            {{ system.name }}
        </h3>
        <p>Lorem Ipsum dolor et ineger.</p>
    </div>
</template>

<script>
export default {
    props: {
        system: {
            type: Object,
            required: true,
            default: () => []
        },

        activeSystemId: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            startMousePosition: {
                x: null,
                y: null
            },
            endMousePosition: {
                x: null,
                y: null
            }
        };
    },

    computed: {
        imageSrc() {
            return require(`@/assets/images/memogenius/system/icon/${this.system.id}.png`);
        },

        userClickedNotDragged() {
            return (
                this.startMousePosition.x === this.endMousePosition.x &&
                this.startMousePosition.y === this.endMousePosition.y
            );
        }
    },

    methods: {
        setMousePosition(e) {
            if (e.type === 'mousedown') {
                this.startMousePosition = {
                    x: e.clientX,
                    y: e.clientY
                };
            } else {
                this.endMousePosition = {
                    x: e.clientX,
                    y: e.clientY
                };
            }
        },

        handleClick() {
            // blocking click event when carousel being dragged
            if (this.userClickedNotDragged) {
                this.$emit('systemClicked', { systemId: this.system.id });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.SystemsCarouselItem {
    .CarouselCard {
        width: 232px;
        height: 363px;
        box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
        border-radius: 4px;
        background: #fdfdfd;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        box-shadow: 0px 2px 23px 3px #4f4f4f 10%;
        h4 {
            margin: 1.5em 0 0 1em;
            align-self: flex-start;
            font-weight: normal;
            font-size: 16px;
            color: #727272;
        }

        img {
            width: 5em;
            height: 5em;
            margin: auto;
        }
    }
    .title {
        color: black;
        font-weight: 500;
        font-size: 20px;
        margin: 1em 0 0.5em;
    }
    p {
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #727272;
        margin-top: 0;
    }
}
</style>
